import { render, staticRenderFns } from "./FilesPreviewSlider.vue?vue&type=template&id=213f6810&"
import script from "./FilesPreviewSlider.vue?vue&type=script&lang=js&"
export * from "./FilesPreviewSlider.vue?vue&type=script&lang=js&"
import style0 from "./FilesPreviewSlider.vue?vue&type=style&index=0&id=213f6810&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports